import {CCCToIBAN} from '../fields/handlers/handlers'
import { getAge } from './helpers'

// Validate fields input
function validate(element) {
  var patterns = []
  for (var i in fields_json.main_fields) {
    patterns.push({
      "field_name": fields_json.main_fields[i].name,
      "reg": fields_json.main_fields[i].reg,
    })
    if (fields_json.main_fields[i].name == "email") {
      patterns.push({
        "field_name": "email_repeat",
        "reg": fields_json.main_fields[i].reg,
      })
    }
  }
  var val = element.val()
  if (element.attr('name') === 'loan_sum') val = val.split(window.override_sum_separator || ' ').join('')
  var cont = element.closest('.ui-form__field');

  if (element.attr('name') == 'email_repeat') {
    if (element.val().toLowerCase() != $('[name=email]').val().toLowerCase()) {
      trigger_err(cont);
      return false;
    }
  }

  if (element.attr('name') == 'confirm') {
    if (element.val() == "0000") {
      trigger_err(cont);
      return false;
    }
  }

  if (element.attr('name') == "surname_second" && val == "" && (!country.is_MX) && (!country.is_UA)) {
    trigger_success($("[name=surname_second]").closest('.ui-form__field'));
    return true;
  }

  if (element.attr('name') == "zip" && (country.is_MX)) {
    if (element.val().length == 5) {
      $.ajax({
        url: backendurl + '/address/mx?zip=' + element.val(),
        dataType: 'json',
        success: function (data) {
          if (data.is_success) {
            trigger_success($("[name=zip]").closest('.ui-form__field'));
            return true;
          } else {
            trigger_err($("[name=zip]").closest('.ui-form__field'));
            return false;
          }
        },
        error: function (error) {
          trigger_err($("[name=zip]").closest('.ui-form__field'));
          return false;
        }
      });
    } else {
      trigger_err($("[name=zip]").closest('.ui-form__field'));
      return false;
    }
  }
  // Validate for text inputs with regex
  if (val.length > 0 && !element.is('select') && element.attr('type') != 'checkbox') {
    var regex = false;
    $.each(patterns, function (i, item) {
      if (item.field_name == element.attr('name')) regex = new RegExp(item.reg, 'gi');
    });
    if (element.attr('name') == 'bank_account_number') {
      if (country.is_ES) {
        var iban = element.val().split(' ').join('');
        if (iban.length === 20) iban = CCCToIBAN(iban, 'ES')
        if (IBAN.isValid(iban)) {
          trigger_success(cont);
          return true;
        }
      } else if (country.is_MX) {
        if (!clabe.validate(element.val()).ok) {
          if (element.val() == "IGNORE") {
            trigger_success(cont);
            return true;
          } else {
            trigger_err(cont);
            return false;
          }
        }
      } else if (country.is_AR) {
        if (element.val() == "IGNORE") {
          trigger_success(cont);
          return true;
        }
      } else if (country.is_UA) {
        if (element.val() == "IGNORE") {
          trigger_success(cont);
          return true;
        }
      }
    }
    if (element.attr('name') == 'id_number' && country.is_UA && element.val() == "IGNORE") {
      trigger_success(cont);
      return true;
    }
    if (element.attr('name') == 'birthday') {
      if (val.match(regex)) {
        var customerAge = getAge(val)
        if (customerAge >= 17 && customerAge <= 100) {
          trigger_success(cont);
          return true;
        } else {
          cont.find('.ui-form-field-error-message').text(fields_json.params.birthday.invalid_error);
          trigger_err(cont);
          return false;
        }
      }
    }

    if (val.match(regex)) {
      // its valid
      if (element.attr('name') == 'name') localStorage.setItem('customerName', element.val());
      if (element.attr('name') == 'loan_sum') setTimeout(function () {
        localStorage.setItem('amount', element.val());
      }, 80);
      trigger_success(cont);
      return true;
    } else {
      if (element.attr('name') == 'birthday') cont.find('.ui-form-field-error-message').text(fields_json.params.birthday.default_error); // 'Por favor, introduce tu fecha de nacimiento'
      trigger_err(cont);
      return false;
    }
    // Validation for select input
  } else if ((element.is('select')) && val.length > 0) {
    trigger_success(cont);
    return true;
    // Any other mistakes trigger an error
  } else if ((element.attr('type') == 'checkbox' || element.attr('type') == 'radio') && element.prop('checked')) {
    trigger_success(cont);
    return true;
  } else {
    trigger_err(cont);
    return false;
  }
}

// Show any of errors messages
function trigger_err (obj) {
  // Define field types
  var type = obj.find('input').attr('type');
  if (type == 'checkbox') {
    if (obj.find('input').attr('id') != 'moneyman3') {
      var class_name = ".vali"
      if (obj.find('input').attr('id') == "agreement") {
        class_name = ".vali-1"
      }
      if (obj.find('input').attr('id') == "agreement_2") {
        class_name = ".vali-2"
      }
      obj.closest(class_name).find('label').addClass('ui-checkbox_error');
      obj.closest(class_name).find('.ui-form-field-error-message_ui-form').removeClass('hidden');
      obj.closest(class_name).addClass('ui-form__row_default-error-view-visible');
    }
  } else {
    obj.find('.ui-input').addClass('ui-input_error').end()
      .find('.ui-form-field-error-message').removeClass('hidden').end()
      .find('.ui-input__additional').html('<span class="cancel_inputing ui-validation-mark__hint_u8XEN ui-validation-mark__cursorDefault_21PYa"><span class="ui-validation-mark__hintWrapper_gEVs1"><span class="ui-icon ui-icon_border ui-icon_size_12 ui-icon_color_red ui-validation-mark__icon_3q6kK ui-validation-mark__cursorPointer_1J50i"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" class="ui-icon__svg-wrapper"><path class="ui-icon__svg" d="M2.5 2.5l95 95m-95 0l95-95"></path></svg></span></span></span>');
    obj.closest('.ui-form__row').addClass('ui-form__row_default-error-view-visible');
  }

  if (type != 'checkbox') {
    move_progressbar('-', obj);
    calculateProgressbar();
  }
}

// Show all about field is okay!
function trigger_success (obj) {
  var type = obj.find('input').attr('type');
  if (type == 'checkbox') {
    var class_name = ".vali"
    if (obj.find('input').attr('id') == "agreement") {
      class_name = ".vali-1"
    }
    if (obj.find('input').attr('id') == "agreement_2") {
      class_name = ".vali-2"
    }
    obj.closest(class_name).removeClass('ui-form__row_default-error-view-visible');
    obj.closest(class_name).find('label').removeClass('ui-checkbox_error');
    obj.closest(class_name).find('.ui-form-field-error-message_ui-form').addClass('hidden');
  } else {
    obj.find('.ui-input').removeClass('ui-input_error').end()
      .find('.ui-form-field-error-message').addClass('hidden').end()
      .find('.ui-input__additional').html('<span class="ui-validation-mark__hint_u8XEN"><span class="ui-validation-mark__hintWrapper_gEVs1"><span class="ui-icon ui-icon_border ui-icon_size_12 ui-icon_color_green ui-validation-mark__icon_3q6kK"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" class="ui-icon__svg-wrapper"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" class="ui-icon__img"><path class="ui-icon__svg" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M2.5 52.9S21 69.8 30.2 78.3c2.4 2.2 7.1 6.5 7.1 6.5l60.2-69.7"></path></svg></svg></span></span></span>');
    obj.closest('.ui-form__row').removeClass('ui-form__row_default-error-view-visible');
    // If field not empty and its match rules - so we can move progress bar
  }
  if (type != 'checkbox') {
    move_progressbar('+', obj);
    calculateProgressbar();
    trigger_percentreward(false);
  }
}

function move_progressbar (action, field) {
  function getCurrent () {
    let cont
    let value
    if (window.interface_v2) {
      cont = $('.main-content__cyrcle-progress, .fixed-progress__cyrcle')
      value = window.progressPercents
    } else {
      cont = $('.ui-form-progress-bar__progress_zebra')
      let curr_value = cont.attr('style')
      value = (parseFloat(curr_value.match(/[+-]?([0-9]*[.])?[0-9]+/gi)[0]) == 10 ? 0 : parseFloat(curr_value.match(/[+-]?([0-9]*[.])?[0-9]+/gi)[0]))
    }
    return [cont, value]
  }

  function setCurrent (cont, value) {
    window.progressPercents = value
    if (window.interface_v2) {
      cont.css('background', `conic-gradient( #5bb73b ${value * 3.6}deg, #F0F0F0 ${value * 3.6}deg)`)
      cont.find('span').text(`${value}%`)
    } else {
      cont.css('width', value + '%')
    }
  }

  let values = getCurrent()
  let cont = values[0]
  let value = values[1]
  let $field = $(field).find('input')
  let length = Object.keys(window.progress_bar).length
  // Percent rewards giving for fields
  let fields = fields_json.params.progress_bar.percents
  let count = (typeof (fields[$field.attr('name')]) != 'undefined' ? fields[$field.attr('name')] : 1);
  let total_fields_active = $('.form-step.active .ui-form__row:not(.hidden)').length
  if ($field.attr('name') == 'loan_period' || $field.attr('name') == 'loan_sum') return
  // Check if in our object has the same input, because we dont need to calculate input which have been added to progress_bar before.
  if (length > 0 && action == '-' && window.progress_bar[$field.attr('name')]) {
    if (value - count == 0) {
      value = 20
      count = 10
    }
    setCurrent(cont, value - count)
    delete window.progress_bar[$field.attr('name')];
  } else if (length < total_fields_active && action == '+' && !window.progress_bar[$field.attr('name')]) {
    setCurrent(cont, value + count)
    window.progress_bar[$field.attr('name')] = true;
  }
}

function clearProgressbar () {
  window.progress_bar = [];
}

function trigger_percentreward (focused) {
  if (focused) {
    if (window.last_focused === focused.attr('name')) return
    window.last_focused = focused.attr('name')

    if (focused.attr('name') == 'loan_sum' || focused.attr('name') == 'loan_period' || focused.attr('type') == 'checkbox' || focused.attr('type') == 'range') return
    var getName = function (focused) {
      var placeholderText = focused.closest('.ui-form__field').find('.ui-input__label_placeholder-text')
      var placeholderTextRadio = focused.closest('.ui-form__field').find('.ui-radio__text-wrapper').text()
      var placeholderTextSelect = focused.closest('.ui-input__field').attr('placeholder')
      var field_name = ''
      if (placeholderText.length > 0) {
        field_name = placeholderText.text()
      } else {
        field_name = placeholderTextRadio || placeholderTextSelect.replace(' *', '')
      }
      // search ui-input__field
      if (!field_name) field_name = focused.closest('.ui-form__row').find('.ui-select__label').text();
      return field_name
    }
    var field_name = getName(focused)

    // Declare field reward percents obj
    var fields = fields_json.params.progress_bar.percents
    var percents = typeof (fields[focused.attr('name')]) != 'undefined' ? fields[focused.attr('name')] : '1'

    $('.ui-form-progress-bar__hint .cont').show()
    $('.ui-form-progress-bar__hint .percent').text(percents)
    $('.ui-form-progress-bar__hint .field_name').text(field_name);
    if (window.interface_v2 && window.curr_step === 1) {
      $('.ui-form-field-note-message').fadeOut()
      focused.closest('.ui-form__row').append('<div class="ui-form-field-note-message"><div>+<strong>' + percents + '</strong>%</div></div>')
    }
    return false;
  } else {
    var found = false;
    $('.formcontent .ui-form__row:not(.hidden)').each(function () {
      var input = ($(this).find('input').length > 0 ? $(this).find('input') : $(this).find('select'));
      if (input.attr('name') == 'loan_sum' || input.attr('name') == 'loan_period') return;
      if (input.val() == '' && input.attr('type') != 'radio' || $(this).hasClass('ui-form__row_default-error-view-visible') || input.val() == fields_json.params.phone.val) {
        trigger_percentreward(input);
        found = true;
        return false;
      } else if (input.attr('type') == 'radio') {
        var name = input.attr('name'),
          checked = false;
        $('[name=' + name + ']').each(function () {
          if ($(this).prop('checked')) checked = true;
        });
        if (!checked) {
          trigger_percentreward(input);
          found = true;
          return false;
        }
      }
    });
    if (!found) {
      // All fields are filled
      if (window.interface_v2) {
        $('.ui-form-field-note-message').fadeOut()
      }
      $('.ui-form-progress-bar__hint .cont').hide();
      $('.app-form-action-buttons .app-form-action-buttons').next('.ui-form-field-error-message').remove();
    }
  }
}

function calculateProgressbar () {
  function getCurrent () {
    let percent
    if (window.interface_v2) {
      percent = window.progressPercents
    } else {
      percent = $('.ui-form-progress-bar__progress_zebra').attr('style').replace(/[a-z: ;%]+/gm, '');
      percent = percent.substr(0, 2);
    }
    return (percent > 100) ? 100 : percent
  }

  function setCurrent (value) {
    if (window.interface_v2) {
      $('.fixed-progress, .main-content__cyrcle').find('p').html(value)
    } else {
      $('.ui-form-progress-bar .text').html(value)
    }
  }

  setTimeout(function () {
    let percent = getCurrent()
    var amount = (localStorage.getItem('amount') ? localStorage.getItem('amount') : []);
    if ($("[name=country]").val() == '9') {
      //if VN
      amount = (amount.split(' ').join('') / 1).toLocaleString()
    }
    if (amount.length >= 3 && percent != 10) {
      let strongText = fields_json.params.progress_bar.text_1[0]
      var progressBarText = '<strong>' +
        (window.interface_v2 ? strongText.slice(2, strongText.length) : percent + strongText) +
        '</strong>&nbsp;' +
        fields_json.params.progress_bar.text_1[1] +
        amount +
        fields_json.params.progress_bar.text_1[2]
      if ($('[name=provider]').val() == "35") {
        progressBarText = '<strong>' +
          fields_json.params.progress_bar.text_1[0] +
          amount +
          '</strong>&nbsp;' +
          fields_json.params.progress_bar.text_1[1] +
          percent +
          fields_json.params.progress_bar.text_1[2]
      }
      setCurrent(progressBarText);
    } else if (percent == 10) {
      setCurrent('<strong>' + fields_json.params.progress_bar.text_2[0] + '</strong>&nbsp;' + fields_json.params.progress_bar.text_2[1]);
    }
  }, 90);
}

export {validate, trigger_success, trigger_percentreward, trigger_err, move_progressbar, calculateProgressbar, clearProgressbar}